<template>
    <div>
        Dunger Component

        <ComponentView entrypoint="test" id="workers" />
    </div>
</template>

<script>
import { ComponentView } from 'protokol-sdk'
import Docs from '@/views/docs/Index'

export default {
    components: {
        ComponentView
    },

    mounted() {
        window.__protokol__ = {
            modules: {
                '@field': {
                    exports: {
                        default: Docs
                    }
                }
            } 
        }
    }
}
</script>